/** The invite someone arrived through, kept in this browser until they finish setup (30 days). */
const KEY = 'vouchaInvite';
export function rememberInvite(invite) {
  try {
    localStorage.setItem(KEY, JSON.stringify({
      ...invite,
      at: Date.now()
    }));
  } catch (e) {}
}
export function currentInvite() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || 'null');
    return v && Date.now() - v.at < 30 * 86400000 ? v : null;
  } catch (e) {
    return null;
  }
}
export function forgetInvite() {
  try {
    localStorage.removeItem(KEY);
  } catch (e) {}
}
flarum.reg.add('voucha-community', 'common/invite', { rememberInvite: rememberInvite,currentInvite: currentInvite,forgetInvite: forgetInvite, });